import { useCallback, useState } from 'react';
import type React from 'react';

import type { TrackingProperties } from '@change-corgi/tracking-properties';

import { useScrollTracking } from '#src/app/pages/petitionDetails/shared/hooks';
import type { WaypointCallbackArgs } from '#src/app/shared/components/layout/lazy';
import { Waypoint } from '#src/app/shared/components/scroll';

type Props = Readonly<{
	name: string;
	trackingData?: TrackingProperties;
}>;

export const ScrollTrackingWaypoint: React.FC<Props> = ({ name, trackingData }) => {
	const [tracked, setTracked] = useState(false);
	const trackScroll = useScrollTracking();

	const onPositionChange = useCallback(
		({ currentPosition }: WaypointCallbackArgs) => {
			if (tracked || currentPosition === 'below') {
				return;
			}
			trackScroll(name, trackingData);
			setTracked(true);
		},

		// trackingData is not memoized and will trigger recreation
		// of this function if added as a dependency
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[name, tracked, setTracked, trackScroll],
	);

	return <Waypoint onPositionChange={onPositionChange} />;
};
